// extracted by mini-css-extract-plugin
export default {"input":"InputSelector_input__VfeD8","select":"InputSelector_select__XTHuo"};